import { render } from "./ComponenteGrafica.vue?vue&type=template&id=711f0640"
import script from "./ComponenteGrafica.vue?vue&type=script&lang=js"
export * from "./ComponenteGrafica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__